// enum values, converted to upper snake case, should match env var names
// _ENABLED will be automatically appended if needed
// ENABLE_ will be automatically prepended if needed
// _TENANTS will be automatically appended and checked against FlagAttributes.tenantId if found
// _PRODUCTS will be automatically appended and checked against FlagAttributes.appliedProductId if found
export var FeatureFlag;
(function (FeatureFlag) {
    FeatureFlag["HighCCPaymentEmails"] = "highCcPaymentsEmail";
    FeatureFlag["ApplyPaymentInEpic"] = "applyPaymentInEpic";
    FeatureFlag["AccountManagement"] = "accountManagement";
    FeatureFlag["LockboxCron"] = "lockboxCron";
    FeatureFlag["PaymentMethodCheckoutB"] = "paymentMethodCheckoutB";
    FeatureFlag["PendoTracking"] = "pendoTracking";
    FeatureFlag["ApplePay"] = "applePay";
    FeatureFlag["GooglePay"] = "googlePay";
    FeatureFlag["PaymentReminders"] = "paymentReminders";
})(FeatureFlag || (FeatureFlag = {}));
export const flagDefaults = {
    [FeatureFlag.HighCCPaymentEmails]: false,
    [FeatureFlag.ApplyPaymentInEpic]: false,
    [FeatureFlag.AccountManagement]: true,
    [FeatureFlag.LockboxCron]: true,
    [FeatureFlag.PaymentMethodCheckoutB]: false,
    [FeatureFlag.PendoTracking]: false,
    [FeatureFlag.ApplePay]: false,
    [FeatureFlag.GooglePay]: false,
    [FeatureFlag.PaymentReminders]: false,
};
export const addIsEnabledToFlags = (flags) => Object.entries(flags).reduce((o, [flag, value]) => (Object.assign(Object.assign({}, o), { [`is${flag.slice(0, 1).toUpperCase()}${flag.slice(1)}Enabled`]: value })), {});
//# sourceMappingURL=FeatureFlags.js.map